import Grid from '@material-ui/core/Grid';
import TextField from '@mui/material/TextField';
import { Autocomplete } from '@mui/material';
import { useEffect, useState, memo } from 'react';
import { Formik, useFormik, FormikProvider, Field } from 'formik';
import Chip from '@mui/material/Chip';
import {DebounceInput} from 'react-debounce-input';
import InputAdornment from '@mui/material/InputAdornment';
import SearchIcon from '@mui/icons-material/Search';
import Checkbox from '@mui/material/Checkbox';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import { isEqual } from 'lodash';


const CHIP_MAX_WIDTH =  100;
const CHIP_ICON_WIDTH = 30;

const uncheckedIcon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

const EllipsisText = (props) => {
  const { children } = props

  return (
    <div style={{
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
      maxWidth: CHIP_MAX_WIDTH - CHIP_ICON_WIDTH
      }}>
      {children}
    </div>
  )
}

const SangerRowPrimers = memo((props) => {
  const data = props.data;
  const submitShowError = props.submitShowError;
  const primerMapToList = props.primerMapToList;
  const primerColors = props.primerColors;
  const reactCount = props.reactCount;
  const reactCountLimit = reactCount >= 96;
  const updateSample = props.updateSample;
  const primers = props.primers;
  const errorPrimers = props.errorPrimers;

  const [selectedPrimers, setSelectedPrimers] = useState([])
  useEffect(() => {
    var selectedPrimersCopy = []
    data.primerRowList.forEach((key) => {
      if (primers.get(key) != undefined) {
        selectedPrimersCopy.push({
          key: key,
          primerName: primers.get(key).primerName
        })
      }
    })
    setSelectedPrimers(selectedPrimersCopy)
  }, [data.primerRowList.length])
  
  return (
  <Grid item>
      <Autocomplete
      freeSolo
      multiple
    // forcePopupIcon={true}
      // disablePortal={true}
      disableCloseOnSelect
      size="small"
      id="primerList"
      variant="outlined"
      options={primerMapToList}
      value={selectedPrimers}
      disabled={primerMapToList.length == 0 || data.premixed}
      onBlur={(e) => {
        var newTouched = [...data.touched];
        newTouched[1] = true;
        updateSample({ touched: newTouched }, props.id);
      }}
      // getOptionDisabled={option => option.primerName == ''}
      getOptionLabel={(option) => option.primerName}
      isOptionEqualToValue={(option, value) => option.key === value.key}
      getOptionDisabled={(option) => reactCountLimit && !data.primerRowList.includes(option.key)}
        renderTags={(value, getTagProps) =>
          value.map((option, index) => (
              <Chip
                  style={{
                    backgroundColor: primerColors.get(option.key),
                    height: 22
                  }}
                  variant="outlined"
                  // label={<div style={{fontSize: 15}}>{primers.get(option.key) ? primers.get(option.key).primerName : ""}</div>}
                  label={<EllipsisText>{primers.get(option.key) ? primers.get(option.key).primerName : ""}</EllipsisText>}
                  {...getTagProps({ index })}
              />
          ))
      }
      onChange={async (e, currData, reason, detail) => {
        if (reason === 'remove-option') {
          console.log(detail.option);
          console.log("DETAIL OPTION")
        };
        var newList = [];
        currData.map((dataSelected, index) => {
          if (typeof dataSelected === 'object') {
            newList.push(dataSelected.key)
          }
        })
        var newTouched = [...data.touched];
        newTouched[1] = true;
        updateSample({ primerRowList: newList, touched: newTouched }, props.id);
      }}
      renderOption={(props, option, { selected }) => (
        <li {...props}
        style={{
          backgroundColor: primerColors.get(option.key)
        }}>
          <Checkbox
            icon={uncheckedIcon}
            checkedIcon={checkedIcon}
            style={{ marginLeft:-20, marginRight: -5 }}
            checked={selected}
          />
          <div style={{flexWrap: 'wrap', wordWrap: 'break-word', width: 140}}>
          {option.primerName}
          </div>
        </li>
      )}
      sx={{ width: 170, '& .MuiInputBase-root': {minHeight: 40, borderRadius: 0}, '& legend': { display: 'none' },
      '& fieldset': { top: 0 }, }}
      renderInput={(params) => (
        // console.log(params),
        <TextField
          {...params}
          onBlur={() => {
            var newTouched = [...data.touched];
            newTouched[1] = true;
            updateSample({ touched: newTouched }, props.id);
          }}
          // label="Primers"
          placeholder={data.premixed ? 'Sample is premixed' : 'Primers'}
          error={((data.touched[1] || submitShowError)) && errorPrimers(data.primerRowList, data.premixed)}
          InputProps={{...params.InputProps,startAdornment: (
            !data.premixed ? (
            <>
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
              {params.InputProps.startAdornment}
            </>) : (<>
            </>)
          )}}
          
        />
      )}
    />
</Grid>);
},
(prevProps, nextProps) => {
    return prevProps.id === nextProps.id && prevProps.data.primerRowList === nextProps.data.primerRowList 
    // && prevProps.primers == nextProps.primers 
    && prevProps.data.touched[1] == nextProps.data.touched[1]
    && prevProps.primerMapToList == nextProps.primerMapToList
    && prevProps.data.premixed == nextProps.data.premixed;
});

export default SangerRowPrimers;